<template>
  <div class="min-h-full flex">
    <div class="max-w-1440 w-full p-15 mx-auto">
      <div class="max-w-500 mx-auto text-center h-full flex">
        <div class="m-auto">
          <i class="icon-check-circle text-green-500 text-50" />
          <p class="text-22 text-green-500 md:text-30 font-bold">Thank You</p>

          <p key="step2" class="text-16 mb-15 md:mb-40">Your payment is successfully done</p>

          <ButtonModule
            text="back to Home"
            :has-hover="true"
            class="text-brand text-18"
            prefix="icon-keyboard-arrow-left text-13"
            @click="goHome"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

import { defineComponent, computed, onMounted, nextTick } from 'vue'
import { useGtag } from 'vue-gtag-next'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'SuccessLogin',

  components: { ButtonModule },

  setup () {
    const router = useRouter()
    const route = useRoute()
    const { event } = useGtag()

    const url = computed(() => {
      return route.query.team
        ? { name: 'TeamBooks', params: { team: 'team' } }
        : { name: 'Books' }
    })

    setTimeout(() => {
      router.push(url.value)
    }, 10000)

    onMounted(() => {
      nextTick(() => {
        if (route.query.team) {
          event('conversion', { send_to: 'AW-597169833/ek_sCNK-qN8CEKmt4JwC' })
          // window.fbq('trackCustom', 'upgradToTeam')
        } else {
          event('conversion', { send_to: 'AW-597169833/OcmlCJji3OYBEKmt4JwC' })
          // window.fbq('trackCustom', 'upgradToPro')
        }
      })
    })

    function goHome () {
      router.push(url.value)
    }

    return {
      goHome
    }
  }
})
</script>
